import * as Types from '../../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CurrentAdministratorQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentAdministratorQuery = { __typename?: 'QueryRoot', currentAdministrator?: { __typename?: 'Administrator', id: string, name: string } | null };


export const CurrentAdministratorDocument = gql`
    query CurrentAdministrator {
  currentAdministrator {
    id
    name
  }
}
    `;

export function useCurrentAdministratorQuery(options?: Omit<Urql.UseQueryArgs<CurrentAdministratorQueryVariables>, 'query'>) {
  return Urql.useQuery<CurrentAdministratorQuery, CurrentAdministratorQueryVariables>({ query: CurrentAdministratorDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCurrentAdministratorQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ currentAdministrator })
 *   )
 * })
 */
export const mockCurrentAdministratorQuery = (resolver: ResponseResolver<GraphQLRequest<CurrentAdministratorQueryVariables>, GraphQLContext<CurrentAdministratorQuery>, any>) =>
  graphql.query<CurrentAdministratorQuery, CurrentAdministratorQueryVariables>(
    'CurrentAdministrator',
    resolver
  )
